import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicPageMutationKeys } from '../../../keys'
import {
	CreateDynamicPageRequest,
	CreateDynamicPageResponse,
} from '../../../type'
import { createDynamicPage } from '../../services'

interface UseMutationCreateDynamicPageProps {
	payload: CreateDynamicPageRequest
}

export default function useMutationCreateDynamicPage(
	props?: UseBaseMutationOptions<
		CreateDynamicPageResponse,
		UseMutationCreateDynamicPageProps
	>,
) {
	return useMutation({
		mutationKey: [DynamicPageMutationKeys.CreateDynamicPage],
		mutationFn: (params) => createDynamicPage(params.payload),
		...props,
	})
}
